import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { requestApi } from "../../../request-api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";
import Dropdown from "../../layouts/dropdown/Dropdown";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import exportIcon from '../../../assets/image/document-download.png';
function ActivityLog() {
  let [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const dropdownRef = useRef(null);
  const dateDropdownRef = useRef(null);
  const [activityLogs, setActivityLogs] = useState([]);
  const [filteredActivityLogs, setFilteredActivityLogs] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");
  const [companySearchName, setCompanySearchName] = useState("");
  const [branchSearchName, setBranchSearchName] = useState("");
  const [companies, setCompanies] = useState([]);
  const [branches, setBranches] = useState([]);
  const [complianceOfficerIdToName, setComplianceOfficerIdToName] = useState({});
  const [activeFilter, setActiveFilter] = useState(null);
  const dropdownRef2 = useRef(null);
  const [showDropdown1, setShowDropdown1] = useState(false);

  const getComplianceOfficerName = (item) => {
    const compliancerId =
      item?.compliancer_id ?? item?.compliancerId ?? item?.compliancer_id_fk ?? null;
    if (compliancerId != null && complianceOfficerIdToName[String(compliancerId)]) {
      return complianceOfficerIdToName[String(compliancerId)];
    }
    return "NA";
  };

  const [filterDateWise, setFilterDateWise] = useState({
    endDate: new Date(),
    startDate: new Date(),
  });

  const [format, setFormat] = useState("pdf");
  const [period, setPeriod] = useState("Monthly");
  const formats = [
    { label: "Pdf", icon: "bi-file-earmark-pdf", value: "pdf" },
    { label: "Excel", icon: "bi-file-earmark-excel", value: "excel" },
  ];
  const periods = ["Monthly", "Quarterly", "Semi-Annually", "Annually"];

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredActivityLogs.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(filteredActivityLogs.length / itemsPerPage);
  const visiblePages = 5;
  let startPage = Math.max(1, currentPage - Math.floor(visiblePages / 2));
  let endPage = startPage + visiblePages - 1;
  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - visiblePages + 1);
  }
  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const toggleDropdown1 = () => {
    setShowDropdown1((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef2.current &&
        !dropdownRef2.current.contains(event.target)
      ) {
        setShowDropdown1(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    if (isOpen1) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen1]);

  useEffect(() => {
    getActivityLogData();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const res = await requestApi("/userRole", { method: "get" });
        const users = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];

        const complianceOfficerMap = {};
        users.forEach((u) => {
          const roleId = Number(u?.role_id);
          if (roleId !== 3) return;
          const id = u?.id ?? u?._id ?? u?.user_id ?? u?.userId ?? u?.role_user_id;
          const name = u?.name ?? u?.full_name ?? u?.fullName ?? u?.username ?? u?.email;
          if (id != null && name) {
            complianceOfficerMap[String(id)] = String(name);
          }
        });
        setComplianceOfficerIdToName(complianceOfficerMap);
      } catch (e) {
        setComplianceOfficerIdToName({});
      }
    })();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dateDropdownRef.current &&
        !dateDropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    let filtered = activityLogs;

    if (selectedCompany.length > 0 || selectedBranch.length > 0) {
      filtered = filtered.filter((item) => {
        const matchesCompany =
          selectedCompany.length === 0 ||
          selectedCompany.includes(item.company_name);
        const matchesBranch =
          selectedBranch.length === 0 || selectedBranch.includes(item.branch);
        return matchesCompany && matchesBranch;
      });
    }

    if (searchValue.trim() !== "") {
      const lowerSearch = searchValue.toLowerCase();
      filtered = filtered.filter(
        (item) =>
          (item.company_name?.toLowerCase().includes(lowerSearch) || "") ||
          (item.branch?.toLowerCase().includes(lowerSearch) || "")
      );
    }

    // Show only Compliance Officer (role_id === 3) activity logs.
    // Enforce compliancer_id exists and belongs to a role_id=3 user (via map).
    filtered = (filtered || []).filter((item) => {
      const compliancerId =
        item?.compliancer_id ?? item?.compliancerId ?? item?.compliancer_id_fk ?? null;
      if (compliancerId == null) return false;
      return Boolean(complianceOfficerIdToName[String(compliancerId)]);
    });

    setFilteredActivityLogs(filtered);
  }, [selectedCompany, selectedBranch, searchValue, activityLogs, complianceOfficerIdToName]);

  const handleQuickFilter = (type) => {
    const now = new Date();
    let start = new Date();
    let end = new Date();

    switch (type) {
      case "Today":
        break;
      case "Yesterday":
        start.setDate(now.getDate() - 1);
        end.setDate(now.getDate() - 1);
        break;
      case "Last 7 days":
        start.setDate(now.getDate() - 6);
        break;
      case "Last 30 days":
        start.setDate(now.getDate() - 29);
        break;
      case "Manual":
        setActiveFilter("Manual");
        return;
      default:
        return;
    }

    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    setFilterDateWise({ startDate: start, endDate: end });
    setActiveFilter(type);
    setIsOpen(false); // Close dropdown when quick filter is selected

    // Apply the date filter immediately for quick filters
    // applyQuickDateFilter(start, end);
  };

  const applyQuickDateFilter = (start, end) => {
    const dateFiltered = activityLogs.filter((item) => {
      if (!item.created_at) return false;
      const createdAt = new Date(item.created_at);
      return createdAt >= start && createdAt <= end;
    });

    // Apply other filters to date-filtered results
    let finalFiltered = dateFiltered;

    if (selectedCompany.length > 0 || selectedBranch.length > 0) {
      finalFiltered = finalFiltered.filter((item) => {
        const matchesCompany =
          selectedCompany.length === 0 ||
          selectedCompany.includes(item.company_name);
        const matchesBranch =
          selectedBranch.length === 0 || selectedBranch.includes(item.branch);
        return matchesCompany && matchesBranch;
      });
    }

    if (searchValue.trim() !== "") {
      const lowerSearch = searchValue.toLowerCase();
      finalFiltered = finalFiltered.filter(
        (item) =>
          (item.company_name?.toLowerCase().includes(lowerSearch) || false) ||
          (item.branch?.toLowerCase().includes(lowerSearch) || false)
      );
    }

    setIsOpen(false);
    setFilteredActivityLogs(finalFiltered);
    toast.success(`Found ${finalFiltered.length} records for ${activeFilter}.`);
  };

  const applyDateFilter = () => {
    if (!filterDateWise.startDate || !filterDateWise.endDate) {
      toast.error("Please select both start and end dates.");
      return;
    }

    const start = new Date(filterDateWise.startDate);
    const end = new Date(filterDateWise.endDate);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    const dateFiltered = activityLogs.filter((item) => {
      if (!item.created_at) return false;
      const createdAt = new Date(item.created_at);
      return createdAt >= start && createdAt <= end;
    });

    // Apply other filters to date-filtered results
    let finalFiltered = dateFiltered;

    if (selectedCompany.length > 0 || selectedBranch.length > 0) {
      finalFiltered = finalFiltered.filter((item) => {
        const matchesCompany =
          selectedCompany.length === 0 ||
          selectedCompany.includes(item.company_name);
        const matchesBranch =
          selectedBranch.length === 0 || selectedBranch.includes(item.branch);
        return matchesCompany && matchesBranch;
      });
    }

    if (searchValue.trim() !== "") {
      const lowerSearch = searchValue.toLowerCase();
      finalFiltered = finalFiltered.filter(
        (item) =>
          (item.company_name?.toLowerCase().includes(lowerSearch) || false) ||
          (item.branch?.toLowerCase().includes(lowerSearch) || false)
      );
    }

    setIsOpen(false);
    setFilteredActivityLogs(finalFiltered);
    toast.success(`Found ${finalFiltered.length} records for the selected date range.`);
  };

  const toggleCompanySelection = (item) => {
    setSelectedCompany((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const toggleBranchSelection = (item) => {
    setSelectedBranch((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const toggleDropdown = () => setShowDropdown(!showDropdown);

  const getActivityLogData = async () => {
    setLoading(true);

    try {
      // Fetch all logs first (same approach as dashboards), then filter in UI.
      let logs = [];
      try {
        const resAll = await requestApi("/activity/all", { method: "get" });
        logs = Array.isArray(resAll?.data)
          ? resAll.data
          : Array.isArray(resAll?.data?.data)
            ? resAll.data.data
            : [];
      } catch (e) {
        // fallback to role-scoped endpoint (older behavior)
        const id = await localStorage.getItem("role_id");
        const res = await requestApi(`/activity/activitylog/${id}`, { method: "get" });
        logs = Array.isArray(res?.data) ? res.data : [];
      }

      let _companies = [];
      let _branches = [];

      for (let i = 0; i < logs.length; i++) {
        if (!_companies.find((cn) => cn === logs[i].company_name)) {
          _companies.push(logs[i].company_name);
        }
      }

      for (let i = 0; i < logs.length; i++) {
        if (!_branches.find((bn) => bn === logs[i].branch)) {
          _branches.push(logs[i].branch);
        }
      }

      setCompanies(_companies);
      setBranches(_branches);
      setActivityLogs(logs);
    } catch (err) {
      toast.error("Somting went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const exportReport = (data, format, period) => {
    try {
      if (!data || !Array.isArray(data) || data.length === 0) {
        toast.error("No data available to export.");
        return;
      }

      // Filter data based on selected period (Monthly, Quarterly, Semi-Annually, Annually)
      // Calculate relative periods from current date (last X months/years)
      const now = new Date();
      now.setHours(23, 59, 59, 999); // End of today
      let startDate = new Date(now);

      switch (period) {
        case "Monthly":
          // Last 1 month from today
          startDate.setMonth(now.getMonth() - 1);
          startDate.setHours(0, 0, 0, 0);
          break;
        case "Quarterly":
          // Last 3 months from today
          startDate.setMonth(now.getMonth() - 3);
          startDate.setHours(0, 0, 0, 0);
          break;
        case "Semi-Annually":
          // Last 6 months from today
          startDate.setMonth(now.getMonth() - 6);
          startDate.setHours(0, 0, 0, 0);
          break;
        case "Annually":
          // Last 12 months (1 year) from today
          startDate.setFullYear(now.getFullYear() - 1);
          startDate.setHours(0, 0, 0, 0);
          break;
        default:
          startDate = null;
      }

      let exportData = [...data];

      // Apply period filter based on Date & Time (created_at)
      if (startDate) {
        const startTimestamp = startDate.getTime();
        const endTimestamp = now.getTime();
        
        exportData = exportData.filter((item) => {
          if (!item.created_at) return false;
          
          // Parse the created_at date
          const createdAt = new Date(item.created_at);
          if (isNaN(createdAt.getTime())) return false;
          
          // Use timestamp comparison for reliability
          const itemTimestamp = createdAt.getTime();
          
          // Compare: created_at should be between startDate and now (inclusive)
          return itemTimestamp >= startTimestamp && itemTimestamp <= endTimestamp;
        });
      }

      if (exportData.length === 0) {
        toast.error(`No data found for the selected period (${period}). Period range: ${startDate ? startDate.toLocaleDateString() : 'N/A'} to ${now.toLocaleDateString()}`);
        return;
      }

      if (format === "excel") {
        try {
          // Format data for Excel export with proper column headers
          const formattedData = exportData.map((item, index) => ({
            "Sr No": index + 1,
            "Company Name": item.company_name || "NA",
            "Branch ID": item.branch || "NA",
            "Date & Time": item.created_at
              ? new Date(item.created_at).toLocaleString()
              : "NA",
            "IP Address": item.ip_address || "NA",
            "Compliance Officer": getComplianceOfficerName(item),
            "Activity": item.latest_activity || "NA",
          }));

          const displayHeaders = Object.keys(formattedData[0] || {});

          const uniqueCompanies = [
            ...new Set(
              formattedData
                .map((item) => item["Entity Name"] || item.company_name)
                .filter(Boolean)
            ),
          ];
          let companyNameText = "";
          if (uniqueCompanies.length > 0) {
            companyNameText = uniqueCompanies.join(", ");
          } else {
            companyNameText = "Company Name";
          }

          const uniqueBranches = [
            ...new Set(
              formattedData
                .map((item) => item["Branch ID"] || item.branch)
                .filter(Boolean)
            ),
          ];
          let locationText = "";
          if (uniqueBranches.length > 0) {
            locationText = uniqueBranches.join(", ");
          } else {
            locationText = "All Locations";
          }

          let dateRangeText = period || "All";

          const getColumnLetter = (colIndex) => {
            let temp,
              letter = "";
            while (colIndex > 0) {
              temp = (colIndex - 1) % 26;
              letter = String.fromCharCode(65 + temp) + letter;
              colIndex = (colIndex - temp - 1) / 26;
            }
            return letter;
          };

          const totalCols = displayHeaders.length;
          const lastColLetter = getColumnLetter(totalCols);
          const totalRows = 4 + formattedData.length;

          const worksheet = XLSX.utils.json_to_sheet(formattedData, {
            origin: "A4",
          });

          const colWidths = displayHeaders.map((header) => ({
            wch: Math.max(String(header).length + 5, 18),
          }));
          worksheet["!cols"] = colWidths;

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Activity Log");

          const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

          XlsxPopulate.fromDataAsync(wbout)
            .then((wb) => {
              const sheet = wb.sheet(0);

              // 1. Row 1: Company Name (Left Aligned)
              const companyRange = sheet.range(`A1:${lastColLetter}1`);
              companyRange.merged(true);
              sheet.cell("A1").value(`Company Name: ${companyNameText}`);
              companyRange.style({
                bold: true,
                fontSize: 14,
                wrapText: true,
                horizontalAlignment: "left",
                verticalAlignment: "center",
                fill: "F2F2F2",
                border: true,
              });

              // 2. Row 2: Location (Left Aligned)
              const locationRange = sheet.range(`A2:${lastColLetter}2`);
              locationRange.merged(true);
              sheet.cell("A2").value(`Location: ${locationText}`);
              locationRange.style({
                bold: true,
                fontSize: 11,
                wrapText: true,
                horizontalAlignment: "left",
                verticalAlignment: "center",
                fill: "F2F2F2",
                border: true,
              });

              // 3. Row 3: Period (Left Aligned)
              const dateRange = sheet.range(`A3:${lastColLetter}3`);
              dateRange.merged(true);
              sheet.cell("A3").value(`Period: ${dateRangeText}`);
              dateRange.style({
                bold: true,
                fontSize: 11,
                wrapText: true,
                horizontalAlignment: "left",
                verticalAlignment: "center",
                fill: "F2F2F2",
                border: true,
              });

              // 4. Headings (Row 4): bold, larger text size, text wrapping, highlighted background, borders
              sheet.range(`A4:${lastColLetter}4`).style({
                bold: true,
                fontSize: 12,
                wrapText: true,
                horizontalAlignment: "center",
                verticalAlignment: "center",
                fill: "D9E1F2",
                border: true,
              });

              // 5. Data Contents (Row 5..totalRows): text wrapping, vertical alignment, borders
              if (totalRows >= 5) {
                sheet.range(`A5:${lastColLetter}${totalRows}`).style({
                  wrapText: true,
                  fontSize: 10,
                  verticalAlignment: "center",
                  border: true,
                });
              }

              return wb.outputAsync();
            })
            .then((blob) => {
              const url = window.URL.createObjectURL(new Blob([blob]));
              const a = document.createElement("a");
              a.href = url;
              a.download = `ActivityLog_${period}_${new Date().toISOString().split('T')[0]}.xlsx`;
              a.click();
              window.URL.revokeObjectURL(url);
              toast.success(`Excel file exported successfully! (${exportData.length} records)`);
            })
            .catch((error) => {
              console.error("Excel export error:", error);
              toast.error("Failed to export Excel file. Please try again.");
            });
        } catch (error) {
          console.error("Excel export error:", error);
          toast.error("Failed to export Excel file. Please try again.");
        }
      } else if (format === "pdf") {
        try {
          const newWindow = window.open();

          if (!newWindow) {
            toast.error("Please allow pop-ups to export PDF.");
            return;
          }

          if (exportData.length === 0 || !exportData[0]) {
            toast.error("No data available to export.");
            return;
          }

          // Define column headers for better formatting
          const columnHeaders = [
            { key: "company_name", label: "Company Name" },
            { key: "branch", label: "Branch ID" },
            { key: "created_at", label: "Date & Time" },
            { key: "ip_address", label: "IP Address" },
            { key: "compliancer", label: "Compliance Officer" },
            { key: "latest_activity", label: "Activity" },
          ];

          const tableRows = exportData.map((item, index) => {
            const cells = columnHeaders.map((col) => {
              let value = col.key === "compliancer" ? getComplianceOfficerName(item) : item[col.key];
              if (value === null || value === undefined) value = "NA";
              if (col.key === "created_at" && value !== "NA") {
                value = new Date(value).toLocaleString();
              }
              return `<td>${value}</td>`;
            });
            return `<tr><td>${index + 1}</td>${cells.join("")}</tr>`;
          });

          const htmlContent = `
            <html>
              <head>
                <title>Activity Log Report</title>
                <style>
                  table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 10px;
                  }
                  th, td {
                    border: 1px solid #000;
                    padding: 4px;
                    text-align: left;
                  }
                  th {
                    background-color: #f0f0f0;
                    font-weight: bold;
                  }
                </style>
              </head>
              <body>
                <h2>Activity Log Report - ${period}</h2>
                <p>Total Records: ${exportData.length}</p>
                <p>Export Date: ${new Date().toLocaleString()}</p>
                <table>
                  <thead>
                    <tr>
                      <th>Sr No</th>
                      ${columnHeaders.map((h) => `<th>${h.label}</th>`).join("")}
                    </tr>
                  </thead>
                  <tbody>${tableRows.join("")}</tbody>
                </table>
              </body>
            </html>
          `;
          newWindow.document.write(htmlContent);
          newWindow.document.close();
          newWindow.print();
          toast.success("PDF opened for printing!");
        } catch (error) {
          console.error("PDF export error:", error);
          toast.error("Failed to export PDF. Please try again.");
        }
      }
    } catch (error) {
      console.error("Export error:", error);
      toast.error("An error occurred during export. Please try again.");
    }
  };

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <section className="lyt-section typ-min-height p-5">
      <div className="">
        <div className=" ">
          <div className="d-flex justify-content-between" >
            <div className="d-flex w-100 justify-content-between" >
              <div className="d-flex gap-4">




                <div style={{ position: "relative", display: "flex", gap: "8px" }}>
                  <div style={{ position: "relative" }}>
                    <button
                      className="btn  shadow-sm d-flex align-items-center justify-content-center fh"
                      onClick={() => {
                        setShowSearch(!showSearch);
                        setSearchValue("");
                      }}
                      style={{
                        minWidth: "40px",

                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                        fontSize: "12px"
                      }}
                    >
                      {showSearch ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="black" viewBox="0 0 16 16">
                          <path d="M4.646 4.646a.5.5 0 011.415 0L8 6.586l1.939-1.94a.5.5 0 01.707.708L8.707 7.293l1.939 1.94a.5.5 0 01-.707.707L8 8.001 6.061 9.94a.5.5 0 11-.707-.707L7.293 8 5.354 6.061a.5.5 0 010-.707z" />
                        </svg>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="black" viewBox="0 0 16 16">
                          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0
            1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zm-5.24 1.106a5 5 0 1 1
            0-10 5 5 0 0 1 0 10z" />
                        </svg>
                      )}
                    </button>

                    {showSearch && (
                      <input
                        type="text"
                        placeholder="Search company or branch"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        style={{
                          position: "absolute",
                          top: "45px",
                          left: 0,
                          width: "260px",
                          padding: "8px 10px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          backgroundColor: "#fff",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          zIndex: 10,
                        }}
                      />
                    )}
                  </div>
                </div>

                <Dropdown
                  label="Select Company Name"
                  options={companies}
                  selectedItems={selectedCompany}
                  setSelectedItems={setSelectedCompany}
                />

                <Dropdown
                  label="Select Branch"
                  options={branches}
                  selectedItems={selectedBranch}
                  setSelectedItems={setSelectedBranch}
                />


                <div className="position-relative d-inline-block cal-left" ref={dateDropdownRef}>
                  <button
                    className="btn bg-white border border-secondary-subtle d-flex align-items-center gap-2 w-20"
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                    aria-expanded={isOpen}
                  >
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/747/747310.png"
                      alt="Calendar Icon"
                      width="16"
                      height="16"
                    />
                    <span className="fs-12">
                      {" "}
                      {filterDateWise.startDate?.toLocaleDateString(
                        "en-GB"
                      )} - {filterDateWise.endDate?.toLocaleDateString(
                        "en-GB"
                      )}
                    </span>
                  </button>

                  {isOpen && (
                    <div
                      className="position-absolute mt-2 bg-white border shadow p-3 "
                      style={{ zIndex: 1000, width: 680, right: 0 }}
                    >
                      <div className="row">
                        <div className="col-md-3">
                          <ul className="list-group fs-12">
                            {[
                              "Today",
                              "Yesterday",
                              "Last 7 days",
                              "Last 30 days",
                              "Manual",
                            ].map((label) => (
                              <li
                                key={label}
                                className={`list-group-item fs-12 ${activeFilter === label
                                  ? "bg-light rounded"
                                  : ""
                                  }`}
                                style={{ border: "none", cursor: "pointer" }}
                                onClick={() => handleQuickFilter(label)}
                              >
                                {label}
                              </li>
                            ))}
                          </ul>
                        </div>
                        {activeFilter === "Manual" && (
                        <div className="col-md-9 border-start">
                          <div className="row">
                            <div className="col-md-6">
                              <DatePicker
                                selected={filterDateWise.startDate}
                                onChange={(date) =>
                                  setFilterDateWise((prev) => ({
                                    ...prev,
                                    startDate: date,
                                  }))
                                }
                                inline
                              />
                            </div>
                            <div className="col-md-6">
                              <DatePicker
                                selected={filterDateWise.endDate}
                                onChange={(date) =>
                                  setFilterDateWise((prev) => ({
                                    ...prev,
                                    endDate: date,
                                  }))
                                }
                                inline
                              />
                            </div>
                          </div>
                          <div className="mt-3 d-flex justify-content-between align-items-center">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <span
                                style={{
                                  backgroundColor: "#343a40",
                                  color: "#fff",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                }}
                              >
                                {filterDateWise.startDate?.toLocaleDateString(
                                  "en-GB"
                                )}
                              </span>

                              <span
                                style={{ fontSize: "12px", color: "#000" }}
                              >
                                →
                              </span>

                              <span
                                style={{
                                  backgroundColor: "#343a40",
                                  color: "#fff",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                }}
                              >
                                {filterDateWise.endDate?.toLocaleDateString(
                                  "en-GB"
                                )}
                              </span>
                            </div>
                            <button
                              className="btn btn-dark fs-12"
                              onClick={() => applyDateFilter()}
                            >
                              Apply
                            </button>
                          </div>
                        </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="d-flex gap-4">
                <div className="dropdown" ref={dropdownRef2}>
                  <button
                    className="btn d-flex align-items-center  gap-1 rounded-2 py-1.5 fh"
                    onClick={toggleDropdown1}
                    style={{
                      backgroundColor: "#fff",
                      border: "1px solid #E4E4E7",
                      color: "#1F1F23",
                      fontWeight: 500,
                      padding: "6px 6px",

                    }}
                  >
                    <img
                      src={exportIcon}
                      alt="Export Icon"
                      width="16"
                      height="16"
                    />
                    Export
                  </button>
                  {showDropdown1 && (
                    <div
                      className="card shadow-sm position-absolute mt-2 end-0"
                      style={{
                        width: "200px",
                        zIndex: 9999,
                        transform: "translateX(10px)",
                      }}
                    >
                      <div>
                        <label className="bg-light py-1 px-2 w-100 fs-12" >
                          Format
                        </label>
                        <div className="btn-group w-100 mt-2 px-2">
                          {formats.map((f) => (
                            <button
                              key={f.value}
                              className={`btn ${format === f.value
                                ? "btn-dark"
                                : "btn-outline-dark"
                                }`}
                              onClick={() => setFormat(f.value)}
                            >
                              <i className={`bi ${f.icon}`}></i> {f.label}
                            </button>
                          ))}
                        </div>
                      </div>
                      <div className="mt-3">
                        <label className="bg-light py-1 px-2 w-100 fs-12">
                          Period
                        </label>
                        <div className="bg-light mx-2 p-2">
                          {periods.map((p) => (
                            <div
                              key={p}
                              className="d-flex justify-content-between"
                              style={{
                                fontSize: "12px",
                                cursor: "pointer",
                                margin: "4px 0",
                              }}
                              onClick={() => setPeriod(p)}
                            >
                              <span>{p}</span>
                              <span>{period === p ? "✔" : ""}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="d-flex justify-content-end">
                        <button
                          className="btn btn-dark w-50 mt-3 mb-2 mx-2"
                          onClick={() =>
                            exportReport(filteredActivityLogs, format, period)
                          }
                        >
                          Export
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4">
        <div className="">
          {/* <div className=" p-0">
            <div className="">
              <table className="table  border">
                <thead className="bg-light text-sm text-nowrap fs-12">
                  <tr>
                    <th>
                      <input type="checkbox" />
                    </th>
                    <th>Sr No</th>
                    <th>Company Name</th>
                    <th>Branch ID</th>
                    <th>Date & Time</th>
                    <th>IP Addresses</th>
                    <th>Complince Officer</th>
                    <th>Activity</th>
                  </tr>
                </thead>
                <tbody className="fs-12 table-color">
                  {currentItems?.map((key, i) => {
                    return (
                      <tr key={i}>
                        <td>
                          <input type="checkbox" />
                        </td>
                        <td>{i + 1}</td>
                        <td>{key.company_name ? key.company_name : "NA"}</td>
                        <td>{key.branch ? key.branch : "NA"}</td>
                        <td>
                          {key.created_at
                            ? new Date(key.created_at).toLocaleString()
                            : "NA"}
                        </td>
                        <td>{key.ip_address ? key.ip_address : "NA"}</td>
                        <td>{key.compliancer ? key.compliancer : "NA"}</td>
                        <td>
                          {key.latest_activity ? key.latest_activity : "NA"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div> */}
          <div className="table-scroll">
            <table className="table table-hover align-middle mt-0 rounded vertical-border">
              <thead className="bg-light text-nowrap fs-12 table-color">
                <tr>
                  {/* <th>
          <input type="checkbox" />
        </th> */}
                  <th>Sr No</th>
                  <th>Company Name</th>
                  <th>Branch ID</th>
                  <th>Date & Time</th>
                  <th>IP Addresses</th>
                  <th>Compliance Officer</th>
                  <th>Activity</th>
                </tr>
              </thead>

              <tbody className="table-color fs-12 ">
                {currentItems?.map((key, i) => (
                  <tr key={i}>
                    {/* <td>
            <input type="checkbox" />
          </td> */}
                    <td>{i + 1}</td>
                    <td>{key.company_name || "NA"}</td>
                    <td>{key.branch || "NA"}</td>
                    <td>
                      {key.created_at
                        ? new Date(key.created_at).toLocaleString()
                        : "NA"}
                    </td>
                    <td>{key.ip_address || "NA"}</td>
                    <td>{getComplianceOfficerName(key)}</td>
                    <td>{key.latest_activity || "NA"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center mt-4">
        <div>
          <select
            className="form-select form-select-sm w-auto fs-12"
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
          >
            {[10, 20, 30, 50].map((size) => (
              <option key={size} value={size}>
                {size} per page
              </option>
            ))}
          </select>
        </div>
        <nav>
          <ul className="pagination mb-0 d-flex align-items-center gap-2">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link text-dark border-0 bg-transparent fs-12"
                onClick={handlePrevious}
              >
                Previous
              </button>
            </li>
            {startPage > 1 && (
              <li className="page-item disabled">
                <span className="page-link border-0 bg-transparent">...</span>
              </li>
            )}
            {pageNumbers.map((pageNum) => (
              <li
                key={pageNum}
                className={`page-item ${currentPage === pageNum ? "active" : ""
                  }`}
              >
                <button
                  className={`page-link fw-bold rounded-circle border-0 ${currentPage === pageNum
                    ? "bg-dark text-white rounded-circle"
                    : "bg-transparent text-dark"
                    }`}

                  onClick={() => handlePageChange(pageNum)}
                >
                  {pageNum}
                </button>
              </li>
            ))}
            {endPage < totalPages && (
              <li className="page-item disabled">
                <span className="page-link border-0 bg-transparent">...</span>
              </li>
            )}

            <li
              className={`page-item ${currentPage === totalPages ? "disabled" : ""
                }`}
            >
              <button
                className="page-link text-dark border-0 bg-transparent fs-12"
                onClick={handleNext}
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </section>
  );
}

export default ActivityLog;
